import styled from "@emotion/styled";
import HeaderLayout from "components/header-layout";
import AppInfoSection from "components/profile/app-info-section";
import TrialBanner from "components/trial-banner";

const Container = styled.div`
    width: clamp(400px, 50%, 500px);
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding: 2rem 1rem 0rem 1rem;
    margin: 0 auto 16px;
`;

const Settings = () => {
    return (
        <HeaderLayout>
            <Container>
                <AppInfoSection />
            </Container>
            <TrialBanner />
        </HeaderLayout>
    );
};

export default Settings;
